export default __webpack_public_path__ + "static/2-68bf8e01137865134f1c45ae454a8ed6.jpg";